<template>
  <section class="section-container" v-if="!is_supplier">
    <div class="content-wrapper">
      <contentheading
        :button="$t('workers.add')"
        :title="$t('workers.title')"
        url="worker_add"/>
      <div class="row">
        <div class="col-xl-12">
          <div class="card">
            <div class="card-body">
              <div class="dataTables_wrapper container-fluid dt-bootstrap4 no-footer">
                <search @make_search="make_search"/>
                <div class="table-responsive">
                    <table class="table table-striped dataTable my-4 w-100" id="workers">
                      <thead>
                        <tr>
                          <th
                            :class="{
                              'sorting_asc': ordering === 'first_name',
                              'sorting_desc': ordering === '-first_name'}"
                            @click="order('first_name')">{{ $t('workers.first-name') }}
                          </th>
                          <th
                            :class="{
                              'sorting_asc': ordering === 'last_name',
                              'sorting_desc': ordering === '-last_name'}"
                            @click="order('last_name')">{{ $t('workers.last-name') }}
                          </th>
                          <th
                            :class="{
                              'sorting_asc': ordering === 'email',
                              'sorting_desc': ordering === '-email'}"
                            @click="order('email')">{{ $t('workers.email') }}
                          </th>
                          <th
                            :class="{
                              'sorting_asc': ordering === 'personal_code',
                              'sorting_desc': ordering === '-personal_code'}"
                            @click="order('personal_code')">{{ $t('workers.personal-code') }}
                          </th>
                          <th>{{ $t('workers.bc-code') }}</th>
                          <th
                            :class="{
                              'sorting_asc': ordering === 'phone',
                              'sorting_desc': ordering === '-phone'}"
                            @click="order('phone')">{{ $t('workers.phone') }}
                          </th>
                          <th
                            :class="{
                              'sorting_asc': ordering === 'group',
                              'sorting_desc': ordering === '-group'}"
                            @click="order('group')">{{ $t('workers.role') }}
                          </th>
                          <th
                            :class="{
                              'sorting_asc': ordering === 'position',
                              'sorting_desc': ordering === '-position'}"
                            @click="order('position')">{{ $t('workers.position') }}
                          </th>
                          <th>{{ $t('workers.groups') }}</th>
                          <th
                            :class="{
                              'sorting_asc': ordering === 'is_active',
                              'sorting_desc': ordering === '-is_active'}"
                            @click="order('is_active')">{{ $t('workers.status') }}
                          </th>
                          <th
                            :class="{
                              'sorting_asc': ordering === 'last_login',
                              'sorting_desc': ordering === '-last_login'}"
                            @click="order('last_login')">{{ $t('workers.last-login') }}
                          </th>
                          <th class="wd-xs"></th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr :key="row.id" class="gradeX" v-for="(row, index) in rows">
                          <td>{{ row.first_name }}</td>
                          <td>{{ row.last_name }}</td>
                          <td>{{ row.email }}</td>
                          <td>{{ row.personal_code }}</td>
                          <td>{{ row.bc_code }}</td>
                          <td>{{ row.phone }}</td>
                          <td>{{ row.group_label }}</td>
                          <td>{{ row.position }}</td>
                          <td>{{ row.warehouse_groups_tags }}</td>
                          <td>{{ row.is_active ? 'Active': 'Disabled' }}</td>
                          <td>{{ row.last_login | formatDateTime }}</td>
                          <td>
                            <div class="btn-group">
                              <router-link
                                :to="{name: 'worker_edit', params: {id: row.id}}"
                                :title="$t('workers.button-edit')"
                                class="far fa-edit btn btn-link link-unstyled px-1 py-2 text-info">
                              </router-link>
                              <button class="btn btn-link pl-1 pt-1 text-info" :title="$t('workers.button-delete')" @click="remove_account(row.id, index)">
                                <i class="far fa-trash-alt"></i>
                              </button>
                            </div>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                </div>
                <pagination
                  :page="page"
                  :pages="pages"
                  :count="count"
                  :from="(page - 1) * page_size + 1"
                  :to="(page - 1) * page_size + rows.length"
                  @paginate="paginate"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import api from '@/api'
import Contentheading from '@/components/Contentheading.vue'
import message from '@/message'
import Pagination from '@/components/Pagination.vue'
import Search from '@/components/Search.vue'

const getData = (route, next) => {
  const search = route.query.search
  const ordering = route.query.ordering || 'first_name'
  const page = parseInt(route.query.page) || 1

  let stored_page_size = JSON.parse(localStorage.getItem('etend.page_size'))
      || {}
  let page_size = route.query.page_size
      || stored_page_size[route.name]
      || process.env.DEFAULT_PAGE_SIZE

  api.get('/workers/', {
    params: {
      search: search,
      ordering: ordering,
      page: page,
      page_size: page_size
    }
  })
    .then(resp => {
      next({
        rows: resp.data.results,
        search: search,
        ordering: ordering,
        pages: resp.data.pages,
        count: resp.data.count,
        page: page,
        page_size: page_size
      })
    })
}

export default {
  components: {
    contentheading: Contentheading,
    pagination: Pagination,
    search: Search
  },
  data () {
    return {
      rows: [],
      search: null,
      ordering: null,
      pages: null,
      count: null,
      page: null,
      page_size: null
    }
  },
  computed: {
    is_supplier () {
      return this.$store.getters.user_group === 'Supplier'
    }
  },
  mounted () {
    this.$parent.menu = 'users'
    this.$parent.submenu = 'workers'
    this.$i18n.locale = this.$store.getters.language
  },
  methods: {
    remove_account (id, index) {
      this.$swal({
        type: 'warning',
        title: this.$i18n.t('workers.are-you-sure'),
        text: this.$i18n.t('workers.are-you-sure-text-cancel'),
        showCancelButton: true
      })
        .then((choice) => {
          if (choice.value) {
            api.post('/remove_account/', {
              user_id: id
            })
              .then(() => {
                message.success(this.$i18n.t('workers.account-deleted'))
                this.$delete(this.rows, index)
              })
              .catch(() => {
                message.error(this.$i18n.t('workers.forbidden'))
              })
          }
        })
    },
    order (o) {
      this.$parent.order(o, this.search, this.ordering)
    },
    paginate (p) {
      this.$parent.paginate(p, this.search, this.ordering)
    },
    make_search () {
      this.$parent.make_search(this.search, this.ordering)
    }
  },
  beforeRouteEnter (to, from, next) {
    getData(to, data => {
      next(vm => {
        Object.assign(vm.$data, data)
      })
    })
  },
  beforeRouteUpdate (to, from, next) {
    getData(to, data => {
      Object.assign(this.$data, data)
      next()
    })
  }
}
</script>



// WEBPACK FOOTER //
// src/views/Workers.vue